// export const locationIqToken = "pk.8bcbb70089caaffc7d845434863cbaaa"; // dmaushov@gmail.com
export const locationIqToken = "pk.be0886d20c9b3bb5637f590c9c7673f3"; // hello@timezones.digital
